import React from 'react';
import { Box } from '../Box/Box';
export var Well = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'gray' : _props$color;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: color === 'yellow' ? 'yellow-lightest' : 'neutral-lightest',
    className: className,
    ref: ref
  }, children);
});
Well.displayName = 'Well';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  var PropTypes = require('prop-types');

  Well.propTypes = {
    /**
     * The content to be rendered inside the Well.
     */
    children: PropTypes.node.isRequired,

    /**
     * Additional classes to apply to the Well.
     */
    className: PropTypes.string,

    /**
     * The background color of the Well. Yellow is used to create
     * a more emphasized background treatment.
     */
    color: PropTypes.oneOf(['gray', 'yellow'])
  };
}